import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Facebook from "../../icons/Facebook";
import X from "../../icons/X";
import Instagram from "../../icons/Instagram";
import LinkedIn from "../../icons/Linkedin";
import { AppContext } from "contexts/AppContext";
import ExplainerTextTiny from "components/elements/ExplainerTextTiny";
import Headline6 from "components/elements/Headline6";
import Activity from "utils/Activity";
import moment from "moment";
import SectionWrapper from "components/layouts/SectionWrapper";
import FooterSections from "./FooterSections";
import { Box } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";

const Footer = () => {
  const { brandData, styleGuide, accessibleShops } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const ShopID = accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null
  const FooterPosition = {
    display: "flex",
    flexDirection: "column",
    marginTop: '100px',
    padding: 0
  };

  const footerBackgroundColor = brandData?.features?.footerBgColor || styleGuide.color7
  
  const FooterHeadline = {
    color: brandData?.features?.footerTextColor || styleGuide.color1
  };

  const FooterLink = {
    cursor: "pointer",
    color: brandData?.features?.footerTextColor || styleGuide.color1
  };

  const isStarkBrand = brandData && brandData.BrandID === 87;

  return (
    <Container fluid style={FooterPosition} id="footer">
      {(location.pathname === '/help' || location.pathname === '/' ) && !!brandData?.features?.useNewHomePage &&
        <FooterSections placement={location.pathname === '/help' ? 'FAQ' : 'FRONT'} />
      }

      <SectionWrapper backgroundColor={footerBackgroundColor}>
        <Box display={'flex'} paddingY={10} gap={{xs: 4, md: 8, lg: 12, xl: 16}} justifyContent={'space-between'} flexDirection={{xs: 'column', md: 'row'}}>
          <Box flex={1} display={'flex'} flexDirection={'column'} gap={1}>
            <Headline6
              style={FooterHeadline}
              translationKey="_PROFILE_MIN_PROFILE_"
              fallbackText="Din profil"
            />

            {!brandData?.features?.disableProfilePointsPage &&
              <ContentNormal
                style={FooterLink}
                translationKey="_PROFILE_MENU_POINTS_"
                fallbackText="Point"
                onClick={() => {
                  Activity({activityType: 'click', activityName: 'footer', activityArgument: 'FAQ', activityArgumentID: ''})
                  navigate('/profile/points')
                }}
              />
            }

            {!!brandData?.features?.enableWalletActivation && !brandData?.features?.disableProfileTaxPage &&
              <ContentNormal
                style={FooterLink}
                translationKey="_PROFILE_MENU_TAX_"
                fallbackText="Beskatning"
                onClick={() => navigate('/profile/tax')}
              />
            }

            <ContentNormal
              style={FooterLink}
              translationKey="_PROFILE_MENU_ORDERS_"
              fallbackText="Ordrer"
              onClick={() => navigate('/profile/orders')}
            />

            {!!brandData?.features?.Inbox &&
              <ContentNormal
                style={FooterLink}
                translationKey="_PROFILE_MENU_INBOX_"
                fallbackText="Beskeder"
                onClick={() => navigate('/profile/messages')}
              />
            }

            {(!brandData?.features?.disableProfileStatistic) &&
              <ContentNormal
                style={FooterLink}
                translationKey="_PROFILE_MENU_SETTINGS_"
                fallbackText="Indstillinger"
                onClick={() => navigate('/profile/settings')}
              />
            }

            {isStarkBrand && 
              <ContentNormal
                style={FooterLink}
                onClick={() => {
                  Activity({ activityType: 'click', activityName: 'footer', activityArgument: 'TermsAndCondition', activityArgumentID: '' })
                  window.open('https://www.stark.dk/Om-Stark/PointShop-MedlemsBetingelser', '_blank')
                }}
              >
                Vilkår og betingelser
              </ContentNormal>
            }
          </Box>

          <Box flex={1} display={'flex'} flexDirection={'column'} gap={1}>
            <Headline6
              style={FooterHeadline}
              translationKey="_FOOTER_SHOP_HEADLINE_"
              fallbackText="Shop"
            />

            <ContentNormal
              style={FooterLink}
              translationKey="_FOOTER_PRODUCTS_"
              fallbackText="Se produkter"
              onClick={() => navigate(`/shop/${ShopID}`)}
            />

            {!brandData?.features?.disableWishlist &&
              <ContentNormal
                style={FooterLink}
                translationKey="_PROFILE_MENU_WISHLIST_"
                fallbackText="Ønskeliste"
                onClick={() => navigate('/profile/wishlist')}
              />
            }

            <ContentNormal
              style={FooterLink}
              translationKey="_PROFILE_SETTINGS_PREFERENCES_HEADLINE_"
              fallbackText="Præferencer"
              onClick={() => navigate('/profile/settings')}
            />
          </Box>

          <Box flex={1} display={'flex'} flexDirection={'column'} gap={1}>
            <Headline6
              style={FooterHeadline}
              translationKey="_PROFILE_FAQ_HEADLINE_"
              fallbackText="Har du spørgsmål?"
            />

            <ContentNormal
              style={FooterLink}
              translationKey="_FAQ_"
              fallbackText="FAQ"
              onClick={() => navigate('/help')}
            />

            <ContentNormal
              style={FooterLink}
              translationKey="_MENU_CONTACT_"
              fallbackText="Kontakt"
              onClick={() => navigate('/contact')}
            />
          </Box>

          <Box flex={1} display={'flex'} flexDirection={'column'} gap={1}>
            <div>
              <div style={{ display: "flex", flexDirection: "row", gap: 20 }} className="iconItem" >
                {brandData && brandData.features && brandData.features.facebookURL && <div
                  style={FooterLink}
                >
                  <a href={brandData.features.facebookURL} target="_blank"><Facebook fill={brandData?.features?.footerTextColor || styleGuide.color1} /></a>
                </div>}
                {brandData && brandData.features && brandData.features.twitterURL && <div
                  style={FooterLink}
                >
                  <a href={brandData.features.twitterURL} target="_blank"><X fill={brandData?.features?.footerTextColor || styleGuide.color1} /></a>
                </div>}
                {brandData && brandData.features && brandData.features.instagramURL && <div
                  style={FooterLink}
                >
                  <a href={brandData.features.instagramURL} target="_blank"><Instagram fill={brandData?.features?.footerTextColor || styleGuide.color1} /></a>
                </div>}
                {brandData && brandData.features && brandData.features.linkedInURL &&
                  <div
                    style={FooterLink}
                  >
                    <a href={brandData.features.linkedInURL} target="_blank"><LinkedIn fill={brandData?.features?.footerTextColor || styleGuide.color1} /></a>
                  </div>}
              </div>
              <div>
                <ExplainerTextTiny fallbackText={`© ${moment().format("YYYY")} Upgrader A/S`} style={{ color: brandData?.features?.footerTextColor || styleGuide.color1, marginTop: 20, }} />
              </div>
            </div>
          </Box>
        </Box>
      </SectionWrapper>
    </Container>
  );
};

export default Footer;
